// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconReviewUser_loader__2BRDC","root":"IconReviewUser_root__2pxDK"};